module.exports = __webpack_public_path__ + "img/claim-sms-offer.1a0c9e8d.png";